import PageLayout from './PageLayout.component';

const PageLayoutContainer = function ({ children }: { children: React.ReactChild }): JSX.Element {
  return <PageLayout>{children}</PageLayout>;
};

export default PageLayoutContainer;
